import React from 'react'
import AgentVerificationList from './AgentVerificationList'

const AgentVerification = () => {
  return (
    <>
      <div
        className='d-flex flex-row justify-content-between'
        style={{height: '48px', marginBottom: '20px'}}>
        <div className='d-flex flex-column'>
          <span className='fs-3 fw-bold text-gray-900'>Agent Verification</span>
          <span className='text-gray-500 fw-semibold lh-20px fs-7'>Home - Agent Verification</span>
        </div>
      </div>
      <AgentVerificationList />
    </>
  )
}
export default AgentVerification
